module.exports = {
    local: {
      url: 'http://localhost:3001/email'
    },
    server: {
      url: 'https://serve.quota.market/email'
    }
  }
